/**
 * Check API response status and handle errors.
 * @param {Response} response - Fetch response object
 * @param {Function} dispatch - Redux dispatch function
 * @returns {Promise}
 */
export const checkStatus = (response: Response) => {
  if (response.status >= 200 && response.status < 300) {
    return Promise.resolve(response)
  }

  const errorMsg =
    'Es ist ein Fehler aufgetreten, bitte überprüfen Sie Ihre Daten und versuchen Sie es erneut.'

  switch (response.status) {
    case 400:
      // No special handling found in bundle
      break
  }

  return Promise.reject(new Error(errorMsg))
}

export function getBookingURL(
  date: string,
  openDayEventModalInTicketApp: boolean,
) {
  return (
    'https://www.miniatur-wunderland.' +
    (window.jsProps.lang === 'de' ? 'de' : 'com') +
    '/tickets/booking/' +
    date +
    (openDayEventModalInTicketApp ? '/event' : '')
  )
}
